import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoSectionCarousel, { EcoSectionCarouselItemProps } from 'eco-design/sections/eco-section-carousel';
import styles from './index.module.scss';

const CampingPower: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('CampingPower');

    const genPosition = (link: string) => {
        if (typeof window !== 'undefined') {
            return document?.querySelector(`${link} .eco-title`)?.innerHTML ?? document?.querySelector(`${link} .eco-section-title`)?.innerHTML ?? 'none';
        }
        return 'none';
    };

    const itemsA: EcoSectionCarouselItemProps[] = [
        {
            title: t('item1_title'),
            desc: t('item1_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1753672794675/pc-1.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1753672794675/pc-1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1753672671750/h5-1.jpg',
            icon: '',
            isLink: true,
            link: '#ItFits',
            dataLayer: { event: 'uaEvent', event_name: 'click_anchor', position: genPosition('#ItFits'), button_name: t('item1_title') },
        },
        {
            title: t('item2_title'),
            desc: t('item2_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1753672673567/pc-2.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1753672673567/pc-2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1753672672036/h5-2.jpg',
            icon: '',
            isLink: true,
            link: '#ItPowers',
            dataLayer: { event: 'uaEvent', event_name: 'click_anchor', position: genPosition('#ItPowers'), button_name: t('item2_title') },
        },
        {
            title: t('item3_title'),
            desc: t('item3_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1753672673255/pc-3.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1753672673255/pc-3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1753672672545/h5-3.jpg',
            icon: '',
            isLink: true,
            link: '#ItConnects',
            target: '_self',
            dataLayer: { event: 'uaEvent', event_name: 'click_anchor', position: genPosition('#ItConnects'), button_name: t('item3_title') },
        },
        {
            title: t('item4_title'),
            desc: t('item4_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1753672672251/pc-4.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1753672672251/pc-4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1753672672766/h5-4.jpg',
            icon: '',
            isLink: true,
            link: '#TabSwriper1',
            target: '_self',
            dataLayer: { event: 'uaEvent', event_name: 'click_anchor', position: genPosition('#TabSwriper1'), button_name: t('item4_title') },
        },
        {
            title: t('item5_title'),
            desc: t('item5_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1753672672958/pc-5.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1753672672958/pc-5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1753672671690/h5-5.jpg',
            icon: '',
            isLink: true,
            link: '#BuiltTough',
            target: '_self',
            dataLayer: { event: 'uaEvent', event_name: 'click_anchor', position: genPosition('#BuiltTough'), button_name: t('item5_title') },
        },
    ];

    return (
        <div className={`${styles.CampingPower} GtmModuleData-section`} data-section-id={'CampingPower'} id="CampingPower">
            <EcoSpace hPc="180px" />
            <EcoSectionCommon title={t('title')} />
            <div className="">
                <EcoSectionCarousel
                    className="carousel"
                    gtmTitle={t('title')}
                    headerLayout="header-top"
                    pagination
                    items={itemsA}
                    swiperAutoPlay
                    isOpenDotsGTM
                    scrollbar={{
                        hide: true,
                    }}
                    autoplay={{
                        delay: 5000,
                        stopOnLastSlide: false,
                        disableOnInteraction: false,
                        animationNavigationRight: true,
                        viewport: {
                            open: true,
                        },
                    }}
                />
            </div>
        </div>
    );
};

export default CampingPower;
